export default __webpack_public_path__ + "static/media/dashboard.ffe61490.png";